// extracted by mini-css-extract-plugin
export var borderRadius = "_d4-4";
export var large = "_d4-3";
export var logoContainer = "_d4-0";
export var nameLogo = "_d4-2";
export var small = "_d4-1";